// extracted by css-extract-rspack-plugin
export default {"premium-folder-icon":"eEExG6","premiumFolderIcon":"eEExG6"};